import { useState } from 'react'
import { Dialog, DialogContent, IconButton, Box, Typography, Button } from '@mui/material'
import { Close, Apple, Android } from '@mui/icons-material'

const IOS_APP_URL = 'https://apps.apple.com/us/app/make-gay-friends/id6478235888'
const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.wizcomputer.makegayfriends&hl=en_US'

export const DownloadAppPopup = () => {
    const [open, setOpen] = useState(true)

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            PaperProps={{ sx: { borderRadius: 4, maxWidth: 380, textAlign: 'center' } }}
        >
            <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{ position: 'absolute', right: 8, top: 8, color: 'text.secondary', zIndex: 1 }}
            >
                <Close />
            </IconButton>
            <DialogContent sx={{ pt: 4, pb: 3 }}>
                <img
                    src="https://storage.googleapis.com/events.makegayfriends.com/assets/makgf_logo.png"
                    alt="Logo"
                    style={{ height: 48, width: 'auto', marginBottom: 12 }}
                />
                <Typography fontWeight={900} fontSize={19} sx={{
                    background: 'linear-gradient(90deg,#E40303,#FF8C00,#FFED00,#008026,#24408E,#732982)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    mb: 1,
                }}>
                    Get the MakeGayFriends app
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Swipe, chat, and find events on the go — download the app for the full experience.
                </Typography>
                <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', justifyContent: 'center', mb: 1.5 }}>
                    <Button
                        href={IOS_APP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="contained"
                        startIcon={<Apple />}
                        sx={{ borderRadius: 50, textTransform: 'none', fontWeight: 700, background: '#23232b', '&:hover': { background: '#000' } }}
                    >
                        Download on iOS
                    </Button>
                    <Button
                        href={ANDROID_APP_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="contained"
                        startIcon={<Android />}
                        sx={{ borderRadius: 50, textTransform: 'none', fontWeight: 700, background: '#3DDC84', '&:hover': { background: '#2fbd6d' } }}
                    >
                        Get it on Android
                    </Button>
                </Box>
                <Button onClick={() => setOpen(false)} sx={{ textTransform: 'none', color: 'text.secondary' }}>
                    Maybe later
                </Button>
            </DialogContent>
        </Dialog>
    )
}
